import script from "./application.vue?vue&type=script&setup=true&lang=js"
export * from "./application.vue?vue&type=script&setup=true&lang=js"

import "./application.vue?vue&type=style&index=0&id=fe906b88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe906b88"]])

export default __exports__